import { Box, Divider, Typography } from "@mui/material";
import EChart from "../Graphic/charts/EChart";
import { CHART_COLORS } from "../chartPalette";

/**
 * TrendChartCard — a titled card that renders an EChart (Apache ECharts).
 * `chartData` keeps the same shape DynamicChart used: { data: [{label, count}], type, title }.
 */
export const TrendChartCard = ({
  title,
  type = "column",
  chartData,
  colors = CHART_COLORS,
  emptyMessage,
  footer,
  footerNote,
  headerAction,
}) => {
  return (
    <Box className="dyTheme1 dyBorder1 rounded" sx={{ p: 2.5, height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {headerAction}
      </Box>
      <Divider sx={{ mb: 1 }} />
      {emptyMessage ? (
        <Box
          sx={{
            minHeight: 360,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 3,
          }}
        >
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {emptyMessage}
          </Typography>
        </Box>
      ) : (
        <>
          <EChart
            chartData={chartData}
            type={type}
            title={title}
            opacity={0.9}
            colors={colors}
          />
          {(footer || footerNote) && (
            <Box sx={{ mt: 0.5, textAlign: "center" }}>
              {footer && (
                <Typography variant="body2" color="text.primary" display="block">
                  {footer}
                </Typography>
              )}
              {footerNote && (
                <Typography variant="caption" color="text.secondary" display="block">
                  {footerNote}
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default TrendChartCard;
